import Link from "next/link";
import { Trans } from "@lingui/macro";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import { DialogName, triggerDialog } from "@components/core/dialog";
import Label from "@components/shared/label";
import classNames from "@lib/classNames";

export interface ISideBarTopicsProps {
  id?: number;
  key: String;
  label: JSX.Element | String;
  emoji: String;
  newStatus?: boolean;
  hot?: boolean;
  isCustom?: false;
}

export interface CustomTopicPillProps {
  key?: React.Key;
  label: JSX.Element | String;
  emoji: String;
  path: String;
  isCustom?: Boolean;
}

export const topCategories: (CustomTopicPillProps | ISideBarTopicsProps)[] = [
  // {
  //   key: "GE15",
  //   label: <Trans>GE15</Trans>,
  //   emoji: "🗳",
  // },
  {
    key: "Trending",
    label: <Trans>Trending</Trans>,
    emoji: "🔥",
  },
  {
    label: <Trans>Parliament</Trans>,
    emoji: "🎪",
    path: "/topics/parliament_malaysia_2026",
    isCustom: true,
  },
  {
    key: "Good_News",
    label: <Trans>Good News 🎉</Trans>,
    emoji: "",
  },
  {
    key: "News",
    label: <Trans>News</Trans>,
    emoji: "☕",
  },
  {
    key: "World",
    label: <Trans>World</Trans>,
    emoji: "🌎",
  },
  {
    key: "Politics",
    label: <Trans>Politics</Trans>,
    emoji: "♟️",
  },
  {
    key: "Lifestyle",
    label: <Trans>Lifestyle</Trans>,
    emoji: "🏝️",
  },
  {
    key: "Tech",
    label: <Trans>Tech</Trans>,
    emoji: "📱",
  },
  {
    key: "Sports",
    label: <Trans>Sports</Trans>,
    emoji: "🏸",
  },
];

const SideBarTopics: React.FunctionComponent = ({}) => {
  const openMoreTopicsDialog = (event) => {
    event.preventDefault();
    triggerDialog(DialogName.moreTopics);
  };

  return (
    <div className="flex flex-col space-y-6">
      <p className="font-poppins text-lg font-bold text-text-darkest">
        <Trans>Topics to check out</Trans>
      </p>
      <div className="flex flex-wrap">
        {topCategories.map((topic) => {
          if (topic.isCustom != undefined) {
            const props = topic as CustomTopicPillProps;
            return <TopicsPill key={props.path as React.Key} {...props} />;
          } else {
            const props = topic as ISideBarTopicsProps;
            return <TopicsTab key={props.key as React.Key} topic={props} />;
          }
        })}
      </div>
      <div className="group flex flex-row items-center space-x-2">
        <div
          onClick={(event) => {
            openMoreTopicsDialog(event);
          }}
          className="cursor-pointer"
        >
          <Trans>
            <p
              className="transition-color font-sen text-sm text-primary2 underline duration-300 group-hover:text-primary4"
              id="more-topics"
            >
              More topics
            </p>
          </Trans>
        </div>
        <ArrowRightIcon className="transition-color h-4 w-4 text-primary2 duration-300 group-hover:text-primary4" />
      </div>
    </div>
  );
};

interface ITopicTabProps {
  topic: ISideBarTopicsProps;
}

const kTopicsPillBaseClassName =
  "transitions-all duration-300 hover:bg-light-background text-primary4 active:scale-90";

const TopicsPill = ({ label, emoji, path }) => {
  return (
    <Link href={path}>
      <a>
        <div
          className={classNames(
            "mb-2 mr-2 flex flex-row items-center space-x-1 rounded-2xl bg-secondary px-4 py-2",
            kTopicsPillBaseClassName
          )}
        >
          <p className="text-center font-sen text-sm text-primary2">
            {label} {emoji}
          </p>
        </div>
      </a>
    </Link>
  );
};

const TopicsTab: React.FunctionComponent<ITopicTabProps> = ({
  topic: { key, emoji, newStatus, hot, label },
}) => {
  return (
    <Link href={`/news?topic=${key}`}>
      <a>
        <div
          className={classNames(
            "mb-2 mr-2 flex flex-row items-center space-x-1 rounded-2xl bg-secondary px-4 py-2",
            kTopicsPillBaseClassName
          )}
        >
          <p className="text-center font-sen text-sm text-primary2">
            {label} {emoji}
          </p>
          {newStatus ? (
            <Label labelName="new" />
          ) : (
            hot && <Label labelName="hot" />
          )}
        </div>
      </a>
    </Link>
  );
};

export default SideBarTopics;
